const fundsEmbed = document.querySelector('#js-funds-form-embed');

document.addEventListener('DOMContentLoaded', () => {
  if (fundsEmbed) {
    const jqueryScriptPromise = new Promise((resolve, reject) => {
      // Load JS files, insert them into head
      const script = document.createElement('script');
      script.id = 'js-jquery-script';
      script.src = '/dist/scripts/jquery-3.3.1.min.js';
      document.head.appendChild(script);

      function testLoad() {
        if (typeof $ === 'function') {
          resolve('jquery loaded');
        } else {
          setTimeout(() => {
            testLoad();
          }, 300);
        }
      }

      testLoad();
    });

    const jqueryPostMessagingScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = 'js-jquery-post-messaging-script';
      script.src = '/dist/scripts/jquery-postmessagingScript2.0Parent.js';
      document.head.appendChild(script);

      function testLoad() {
        if (typeof pm === 'function') {
          resolve('jquery post messaging script added');
        } else {
          setTimeout(() => {
            testLoad();
          }, 300);
        }
      }

      testLoad();
    });

    Promise.all([jqueryScriptPromise, jqueryPostMessagingScriptPromise]).then(
      () => {
        const script = document.createElement('script');
        script.id = 'js-post-messaging-setup-script';
        script.src = '/dist/scripts/PostMessagingSetup.js';

        document.body.appendChild(script);

        // insert iframe for Financial express
        const iframeSrc = fundsEmbed.dataset.src;
        const iframe = document.createElement('iframe');
        iframe.setAttribute('id', 'js-funds-form-iframe');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('scrolling', 'no');
        iframe.setAttribute('src', iframeSrc);

        fundsEmbed.appendChild(iframe);
      },
    );
  }
});
